export const getCountryName = (country: string): string => {
    if (country === "United States of America" || country === "USA" || country === "United States") {
      return "USA"
    }
    return country;
  }
  